import Papa from "papaparse";

import { createDownloadFileName } from "@/components/UI/TableToolbar/utils";

const DANGEROUS_CSV_PREFIXES = ["=", "+", "-", "@", "\t", "\r"];

function sanitizeCsvCell(value: unknown) {
  if (typeof value !== "string") return value;

  return DANGEROUS_CSV_PREFIXES.some((prefix) => value.startsWith(prefix))
    ? `'${value}`
    : value;
}

export function downloadAdminCsv(rows: object[], fileName: string) {
  if (!rows.length) return;

  const csv = Papa.unparse(
    rows.map((row) =>
      Object.fromEntries(
        Object.entries(row).map(([key, value]) => [
          key,
          sanitizeCsvCell(value),
        ]),
      ),
    ),
  );

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.setAttribute("download", `${createDownloadFileName(fileName)}.csv`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
